import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getStripePriceIdSelector,
  getStripePriceSelector
} from '../redux/features/configuration/configurationSlice';
import {
  PRODUCT_PLANS_BASE,
  PRODUCT_PLANS_INTERVAL_MONTH
} from '../config';

/**
 * Custom hook to get product plans with real-time pricing from Redux.
 * Merges static plan data from PRODUCT_PLANS_BASE with pricing from API.
 *
 * @returns {Array} Array of product plans with populated prices array
 */
export const useProductPlans = () => {
  // Fetch all pricing data from Redux
  const plan1Price = useSelector(getStripePriceSelector(1));
  const plan1PriceId = useSelector(getStripePriceIdSelector(1));

  const plan2Price = useSelector(getStripePriceSelector(2));
  const plan2PriceId = useSelector(getStripePriceIdSelector(2));

  const plan3Price = useSelector(getStripePriceSelector(3));
  const plan3PriceId = useSelector(getStripePriceIdSelector(3));

  const plan4Price = useSelector(getStripePriceSelector(4));
  const plan4PriceId = useSelector(getStripePriceIdSelector(4));

  const plan5Price = useSelector(getStripePriceSelector(5));
  const plan5PriceId = useSelector(getStripePriceIdSelector(5));

  const plan6Price = useSelector(getStripePriceSelector(6));
  const plan6PriceId = useSelector(getStripePriceIdSelector(6));

  const plan7Price = useSelector(getStripePriceSelector(7));
  const plan7PriceId = useSelector(getStripePriceIdSelector(7));

  const plan8Price = useSelector(getStripePriceSelector(8));
  const plan8PriceId = useSelector(getStripePriceIdSelector(8));

  // Create pricing map
  const pricingMap = useMemo(() => ({
    1: { price: plan1Price, id: plan1PriceId },
    2: { price: plan2Price, id: plan2PriceId },
    3: { price: plan3Price, id: plan3PriceId },
    4: { price: plan4Price, id: plan4PriceId },
    5: { price: plan5Price, id: plan5PriceId },
    6: { price: plan6Price, id: plan6PriceId },
    7: { price: plan7Price, id: plan7PriceId },
    8: { price: plan8Price, id: plan8PriceId }
  }), [
    plan1Price, plan1PriceId,
    plan2Price, plan2PriceId,
    plan3Price, plan3PriceId,
    plan4Price, plan4PriceId,
    plan5Price, plan5PriceId,
    plan6Price, plan6PriceId,
    plan7Price, plan7PriceId,
    plan8Price, plan8PriceId
  ]);

  // Merge base plans with pricing
  const productPlans = useMemo(() => {
    return PRODUCT_PLANS_BASE.map((plan) => {
      const pricing = pricingMap[plan.id];
      return {
        ...plan,
        prices: [
          {
            interval: PRODUCT_PLANS_INTERVAL_MONTH,
            id: pricing?.id || '',
            price: pricing?.price || 0
          }
        ]
      };
    });
  }, [pricingMap]);

  return productPlans;
};
